module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/arizona-state-563287d46fbb87ff260ce35efc591510.svg";